class productCard extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;

    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: false,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        990: {
          allowTouchMove: false,
        },
      },
    });
  }
}

customElements.define("product-card", productCard);

// (function () {
//   var scrollFired = false;

//   function saveScroll() {
//     if (window.localStorage) {
//       window.localStorage.setItem(
//         "scrollLeftTop",
//         window.pageXOffset + "," + window.pageYOffset
//       );

//     }
//   }

//   function autoScroll() {
//     scrollFired = true;
//     if (window.localStorage) {
//       var xy = window.localStorage.getItem("scrollLeftTop");
//       if (xy) {
//         var a = xy.split(",");
//         var x = a[0];
//         var y = a[1];
//         window.scroll(x, y);
//       }
//     }
//   }

//   function onLoadAutoScroll() {
//     if (scrollFired === false) {
//       //Prevent scroll if run DOMContentLoaded
//       autoScroll();
//     }
//   }

//   window.addEventListener("DOMContentLoaded", autoScroll, false);
//   window.addEventListener("load", onLoadAutoScroll, false); //If DOMContentLoaded not "run"
//   window.addEventListener("scroll", saveScroll, false);
// })();
